import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=ef457dd6&scoped=true"
import script from "./Locale.vue?vue&type=script&lang=js"
export * from "./Locale.vue?vue&type=script&lang=js"
import style0 from "./Locale.vue?vue&type=style&index=0&id=ef457dd6&prod&lang=scss&scoped=true"
import style1 from "./Locale.vue?vue&type=style&index=1&id=ef457dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef457dd6",
  null
  
)

export default component.exports